import { AreaRepository } from "./area/AreaBaseRepository";
import { StatRepository } from "./stat/StatRepository";
import { AccessPointRepository } from "./accesspoint/AccessPointRepository";
import { StatRemoteRepository } from "./stat/StatRemoteRepository";
import { AccessPointRemoteRepository } from "./accesspoint/AccessPointRemoteRepository";
import { AreaRemoteRepository } from "./area/AreaRemoteRepository";
import { ConfigRepository } from './config/ConfigRepository';
import { ConfigRemoteRepository } from './config/ConfigRemoteRepository';

interface BaseRepositories {
    area: AreaRepository,
    state: StatRepository,
    accessPoint: AccessPointRepository,
    config: ConfigRepository,
}

export const Repositories: BaseRepositories = {
    area: new AreaRemoteRepository(),
    state: new StatRemoteRepository(),
    accessPoint: new AccessPointRemoteRepository(),
    config: new ConfigRemoteRepository(),
};
